function updateStoreifyLinks() {
  document.querySelectorAll('.storeify-storelocator-web').forEach(link => {
    if (link.target !== '_self') {
      link.target = '_self';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateStoreifyLinks();

  const container = document.querySelector('body');

  const observer = new MutationObserver(() => {
    updateStoreifyLinks();
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });
});